import MApplicationSummary from './index.vue';

MApplicationSummary.install = app => {
  app.component(MApplicationSummary.name, MApplicationSummary);
};

export default MApplicationSummary;
